// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio-radio-508b","text":"Radio-text-508b","checked":"Radio-checked-508b","error":"Radio-error-508b"};